// Constants for event reminder push notifications
export const EVENT_REMINDER_JOB_NAME = 'scheduledNotification';
export const SUPPORT_NUMBER = {
  label: '(888) 316-0451',
  raw: '8883160451',
};
